/*
  Store & country popup (cultnaked.com / cultnaked.ua)
  - cultnaked.com + visitor in Ukraine      -> suggests cultnaked.ua
  - cultnaked.com + visitor anywhere else   -> switches to their country/currency
                                               and shows "You're shopping in ..."
  - cultnaked.ua  + visitor outside Ukraine -> suggests cultnaked.com
  - Shown once; the choice is remembered. If detection fails, nothing is shown.
*/
(function () {
  var STORE_KEY = "previously_selected_store";
  var DONE_KEY = "cn_geo_done";
  var PENDING_KEY = "cn_geo_pending";
  var GUARD_KEY = "store_switch_redirect_guard";

  function lsGet(key) { try { return localStorage.getItem(key); } catch (e) { return null; } }
  function lsSet(key, value) { try { localStorage.setItem(key, value); } catch (e) {} }
  function ssGet(key) { try { return sessionStorage.getItem(key); } catch (e) { return null; } }
  function ssSet(key, value) { try { sessionStorage.setItem(key, value); } catch (e) {} }
  function ssRemove(key) { try { sessionStorage.removeItem(key); } catch (e) {} }

  function withCurrentQuery(href) {
    var target;
    try { target = new URL(href, window.location.origin); } catch (e) { return href; }
    new URLSearchParams(window.location.search).forEach(function (value, key) {
      if (key === "switch_store" || key === "variant") return;
      if (!target.searchParams.has(key)) target.searchParams.set(key, value);
    });
    return target.toString();
  }

  function init() {
    var overlay = document.getElementById("store-selector-overlay");
    if (!overlay) return;

    var store = overlay.getAttribute("data-current-store");
    var currentCountry = overlay.getAttribute("data-current-country");
    var available = (overlay.getAttribute("data-available-countries") || "").split(",");
    var form = document.getElementById("CnGeoForm");
    var select = overlay.querySelector("[data-geo-country]");

    function show(viewName) {
      overlay.querySelectorAll("[data-geo-view]").forEach(function (view) {
        view.hidden = view.getAttribute("data-geo-view") !== viewName;
      });
      overlay.classList.remove("hidden");
      var focusTarget = overlay.querySelector('[data-geo-view="' + viewName + '"] .cn-geo__btn');
      if (focusTarget) focusTarget.focus();
    }

    function close() {
      overlay.classList.add("hidden");
      lsSet(DONE_KEY, "1");
    }

    overlay.querySelectorAll("[data-geo-close]").forEach(function (el) {
      el.addEventListener("click", close);
    });
    overlay.addEventListener("click", function (event) {
      if (event.target === overlay) close();
    });
    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && !overlay.classList.contains("hidden")) close();
    });
    overlay.querySelectorAll("[data-store-option-link]").forEach(function (link) {
      link.setAttribute("href", withCurrentQuery(link.getAttribute("href")));
      link.addEventListener("click", function () {
        try { lsSet(STORE_KEY, new URL(link.href).origin); } catch (e) {}
        lsSet(DONE_KEY, "1");
      });
    });
    if (select && form) {
      select.addEventListener("change", function () {
        lsSet(DONE_KEY, "1");
        form.submit();
      });
    }

    // 1. Arrived from the other store's link: remember it and clean the URL.
    var params = new URLSearchParams(window.location.search);
    if (params.has("switch_store")) {
      lsSet(STORE_KEY, window.location.origin);
      lsSet(DONE_KEY, "1");
      ssRemove(GUARD_KEY);
      params.delete("switch_store");
      var query = params.toString();
      history.replaceState(null, "", window.location.pathname + (query ? "?" + query : "") + window.location.hash);
      return;
    }

    // 2. Visitor chose the other store before: send them there (once per session).
    var saved = lsGet(STORE_KEY);
    if (saved) {
      try {
        var savedUrl = new URL(saved);
        if (savedUrl.hostname !== window.location.hostname && ssGet(GUARD_KEY) !== savedUrl.hostname) {
          ssSet(GUARD_KEY, savedUrl.hostname);
          window.location.href = savedUrl.origin + window.location.pathname + window.location.search;
          return;
        }
      } catch (e) {}
    }

    // 3. We just switched the country for them: tell them where they shop now.
    if (ssGet(PENDING_KEY)) {
      ssRemove(PENDING_KEY);
      show("country");
      return;
    }

    // 4. Already handled before.
    if (lsGet(DONE_KEY) || saved) return;
    if (/bot|crawl|spider|slurp|lighthouse/i.test(navigator.userAgent)) return;

    // 5. Detect the country by IP.
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    fetch(root + "browsing_context_suggestions.json?country[enabled]=true", { credentials: "same-origin" })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (data) {
        var detected = data && data.detected_values && data.detected_values.country && data.detected_values.country.handle;
        if (!detected) return;

        if (store === "ua") {
          if (detected !== "UA") show("to-com");
          else lsSet(DONE_KEY, "1");
          return;
        }

        if (detected === "UA") {
          show("to-ua");
          return;
        }

        if (detected !== currentCountry && available.indexOf(detected) > -1 && form && select) {
          ssSet(PENDING_KEY, "1");
          select.value = detected;
          form.submit();
          return;
        }

        show("country");
      })
      .catch(function () {});
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();